import React, { useEffect } from "react";

// components
import {
  Button,  
  Modal,
  Row,
  Col,
} from "reactstrap";
import MaterialTable from "material-table";

// servicse
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";

//Constants
import { table_translate, table_style} from "../../../constants/MaterialTable.js";

export default function ModalPesquisa({stateModalPesquisa, ordemColeta, handleReturn, showLoading}) {
  
    const [stateModal, setstateModal] = React.useState(stateModalPesquisa);

    const [viewEcopontos, setviewEcopontos] = React.useState(false);
    const [viewPlanoTrabalho, setviewPlanoTrabalho] = React.useState(false);
    const [viewAvulso, setviewAvulso] = React.useState(false);
    
    const [list, set_list] = React.useState([]);    
    const loadList = () => {        
        if (ordemColeta == null)
            return;

        showLoading(true);
        api_GET(`pontocoleta/GetListPesquisa/${viewEcopontos}/${viewPlanoTrabalho}/${viewAvulso}/${ordemColeta.modalidadeColetaId}`).then(result => {                            
            showLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else{
                let list = result.data.filter(f => ordemColeta.ordemColetaPontoColeta.filter(i => i.pontoColetaId == f.pontoColetaId).length == 0);                
                set_list(list);
            }
        });
    }

    useEffect(() => {         
        loadList();
    }, [viewEcopontos, viewPlanoTrabalho, viewAvulso]);

    useEffect(() => {         
        setstateModal(stateModalPesquisa);
    }, [stateModalPesquisa]);

    const [listSelected, setListSelected] = React.useState([]);

    const columnsProp = [
        { title: 'Categoria', field: "categoria" },
        { title: 'Endereço', field: "logradouro", render: (rowData) => rowData && (rowData.logradouro + ", " + rowData.numeroLogradouro)},
        { title: 'Bairro', field: "bairro"},
        { title: 'Frequência', field: "frequencia"}
    ]

    return (
        <>
            <Modal
                className="modal-dialog-centered"
                isOpen={stateModal}
                size="lg"                
            >                
                <div className="modal-body">
                    <h4 className="modal-title" id="modal-title-default">
                        Pesquisar
                    </h4>                    
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => handleReturn()}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>                        
                    <Row className="mt-2">
                        <Col md="2">                                                          
                            <div className="custom-control custom-checkbox mb-3">
                                <input
                                    className="custom-control-input"                                    
                                    id="ckEcopontos"
                                    type="checkbox"
                                    onClick={(e) => setviewEcopontos(e.target.checked)}
                                />
                                <label className="custom-control-label" htmlFor="ckEcopontos">
                                    Ecopontos
                                </label>
                            </div>                                                  
                        </Col>
                        <Col md="5">                                                          
                            <div className="custom-control custom-checkbox mb-3 display-inline">
                                <input
                                    className="custom-control-input"                                        
                                    id="ckPlanoTrabalho"
                                    type="checkbox"
                                    onClick={(e) => setviewPlanoTrabalho(e.target.checked)}
                                />
                                <label className="custom-control-label" htmlFor="ckPlanoTrabalho">
                                    Locais de Planos de Trabalho
                                </label>
                            </div>                            
                        </Col>
                        <Col md="5">                                                                                      
                            <div className="custom-control custom-checkbox mb-3 display-inline">
                                <input
                                    className="custom-control-input"                                        
                                    id="ckAvulso"
                                    type="checkbox"
                                    onClick={(e) => setviewAvulso(e.target.checked)}
                                />
                                <label className="custom-control-label" htmlFor="ckAvulso">
                                    Locais Avulsos
                                </label>
                            </div>                            
                        </Col>                        
                    </Row>  
                    <MaterialTable
                        title=""
                        columns={columnsProp}
                        data={list}                        
                        options={{...table_style, selection: true}}             
                        onSelectionChange={(rows) => setListSelected(rows)}              
                        localization={table_translate}  
                    /> 
                </div>
                <div className="modal-footer">
                    <Button color="secondary" type="button" onClick={() => handleReturn(null)}>
                        Cancelar
                    </Button>                
                    <Button outline color="info" type="button" onClick={() => handleReturn(listSelected)}>
                        Incluir no Mapa
                    </Button>                
                </div>
            </Modal>
        </>
    );  
}
